// project imports
import {
    processEntityInput as processEntityInputMain,
    processEntityOutput as processEntityOutputMain
} from 'store/serializers/fragments/main';
import { getIriFromObj } from 'utils/processors';

export const processEntityInput = (values) => ({ ...values, ...processEntityInputMain(values) });

export const processEntityOutput = (values) => ({
    ...values,
    ...processEntityOutputMain(values),
    businessOpportunityType: 'businessOpportunityType' in (values || {}) ? getIriFromObj(values.businessOpportunityType) : undefined
});
